<template>
  <div class="project-overview tab-btn">
    <div class="project-overview-top">
      <SimpleTable
        :allowMultiSelect="false"
        ref="tableLeft"
        :loading="loadingLeft"
        :columns="columnsLeft"
        :data="tableDataLeft"
        @row-select="handleRowSelectLeft"
      />
      <SimpleTable
        :allowMultiSelect="false"
        :show-index="false"
        ref="tableCenter"
        :loading="loadingCenter"
        :columns="columnsCenter"
        :data="tableDataCenter"
        @modify-data-change="handleModifyDataChangeCenter"
      />
      <SimpleTable
        :show-index="false"
        ref="tableRight"
        :loading="loadingRight"
        :columns="columnsRight"
        :data="tableDataRight"
        @modify-data-change="handleModifyDataChangeRight"
      />
    </div>

    <div class="project-overview-bottom">
      <SimpleTable
        :menus="['查询', '上传', '批量删除']"
        :columns="columnsBottom"
        :data="tableDataBottom"
        :loading="loadingBottom"
        :uploadParams="uploadParams"
        @cell-dblclick="handleCellDblclickBottom"
      />
    </div>
  </div>
</template>

<script>
import SimpleTable from '@/components/SimpleTable/index.vue'
import { sortRecords, preViewFile } from '@/utils/index'

export default {
  name: 'ProjectOverview',
  components: { SimpleTable },
  props: {
    businessId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      columnsLeft: [{ field: 'name', title: '工程分类', widht: 100 }],
      columnsCenter: [
        { field: 'name', title: '工程特征', widht: 100 },
        {
          field: 'featureValue',
          title: '特征值',
          width: 200,
          canModify: true,
          editModal: {
            columns: [{ field: 'name', title: '工程特征', tree: true }],
            allowMultiSelect: true,
            options: () => this.getEngineeringFeatureOptions(),
            confirm: (selectedCellInfos, res) => {
              const arr = res.map(e => e[0].originData.name)
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'featureValue', arr.join(' '))
              })
            }
          }
        }
      ],
      columnsRight: [
        { field: 'name', title: '工程参数', widht: 100 },
        {
          field: 'paramValue',
          title: '参数值',
          width: 200,
          fieldType: 'number',
          canEdit: true,
          canModify: true
        }
      ],
      columnsBottom: [
        {
          title: '文件名',
          field: 'name',
          cellType: 'link'
        },
        { title: '后缀', field: 'suffix' },
        { title: '锁号', field: '' },
        { title: '联系人', field: '' },
        { title: '上传时间', field: 'sysCreatedDate' }
      ],

      tableDataLeft: [],
      tableDataCenter: [],
      tableDataRight: [],
      tableDataBottom: [],
      loadingLeft: false,
      loadingCenter: false,
      loadingRight: false,
      loadingBottom: false,
      uploadParams: {
        id: '',
        accept: '',
        uploadAfter: () => this.getTableDataBottom()
      }
    }
  },
  watch: {
    businessId: {
      handler(newVal) {
        if (newVal) {
          this.uploadParams.id = newVal
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
      this.tableDataLeft = []
      this.tableDataCenter = []
      this.tableDataRight = []
      this.tableDataBottom = []

      this.getTableDataLeft()
      this.getTableDataBottom()
    },

    async getTableDataLeft() {
      this.loadingLeft = true
      const res = await this.$service.get(
        '/business-engineering-classify/list',
        {
          businessId: this.businessId
        }
      )
      this.loadingLeft = false
      this.tableDataLeft = sortRecords(res?.data || [])
      if (res.data?.length) this.$refs.tableLeft.initialized()
    },

    async getTableDataCenter(obj) {
      this.loadingCenter = true
      const res = await this.$service.get(
        '/business-engineering-classify/features',
        {
          classifyId: obj.id
        }
      )
      this.loadingCenter = false
      this.tableDataCenter = sortRecords(res?.data || [])
    },

    async getTableDataRight(obj) {
      this.loadingRight = true
      const res = await this.$service.get(
        '/business-engineering-classify/params',
        {
          classifyId: obj.id
        }
      )
      this.loadingRight = false
      this.tableDataRight = sortRecords(res?.data || [])
    },

    async getTableDataBottom() {
      this.loadingBottom = true
      const res = await this.$service.get(
        '/business-file/list/' + this.businessId
      )
      this.loadingBottom = false
      this.tableDataBottom = sortRecords(res?.data || [])
    },

    handleRowSelectLeft() {
      const rows = this.$refs.tableLeft.getSelectData()
      const obj = rows[0]?.[0]?.originData
      this.getTableDataCenter(obj)
      this.getTableDataRight(obj)
    },

    async handleModifyDataChangeCenter(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/features/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async handleModifyDataChangeRight(getModifyData, cleanModifyData) {
      const arr = getModifyData()
      if (!arr.length) return
      const res = await this.$service.post(
        '/business-engineering-classify/params/batch',
        arr
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        cleanModifyData()
      }
    },

    async getEngineeringFeatureOptions() {
      const rows = this.$refs.tableCenter.getSelectData()
      const obj = rows[0]?.[0]?.originData
      const res = await this.$service.get(
        '/engineering-classify/feature-values',
        {
          featureId: obj.sourceId
        }
      )
      return sortRecords(res?.data || [])
    },

    handleCellDblclickBottom(args) {
      preViewFile(args.originData?.path)
    }
  }
}
</script>

<style scoped>
.project-overview {
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 500px;
}
.project-overview > div {
  height: 50%;
}
.project-overview-top {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}
.project-overview-top > div {
  flex: 1;
}
</style>
